const QUERIES = {
  USERS_LIST: 'users-list',
  CAMPAIGN_LIST: 'campaigns-list',
  PERMISSION_LIST: 'permission-list',
  ROLE_LIST: 'role-list',
  TICKET_LIST: 'ticket-list',
  TEMPLATEMESSAGES_LIST: 'templatemessages-list',
  MENU_LIST: 'menu-list',
  LOV_LIST: 'lov-list',
  JOBSCHEDULER_LIST: 'jobscheduler-list',
  DATASOURCE_LIST: 'datasource-list',
  AUTORESPOND_LIST: 'autorespond-list',
}

export {QUERIES}
